export default "__VITE_ASSET__DLjfP68F__"